import { RootState } from '../../store/root-state';
import { Security } from './security';
import { ISecurityGroup } from '../../api-client/autogenerated';

export const getSecurityGroupsState = (state: RootState): Security => state.security.security;

export const getCurrentSecurityGroup = (state: RootState): ISecurityGroup | null | undefined => {
  const project = state.project.project;
  const projectUser = project?.projectUserList?.find(
    (pu) => pu.userId === state.user.user.id,
  );
  if (projectUser?.securityGroupId) {
    return state.security.security.find((sg) => sg.id === projectUser.securityGroupId);
  }
  const companyViewSecurityGroupId = project?.subscriber?.companyViewSecurityGroupId;
  if (companyViewSecurityGroupId) {
    return state.security.security.find((sg) => sg.id === companyViewSecurityGroupId);
  }
  return undefined;
};

export const getSubscriberSecurityGroupState = (state: RootState) =>
  state.security.subscriberSecurity;
